import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export function useCrmListState() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawPage = Number(searchParams.get('page') || 1);
  const page = Number.isSafeInteger(rawPage) && rawPage > 0 ? rawPage : 1;
  const updateParam = (patch: Record<string, string | string[] | null>) => {
    const next = new URLSearchParams(searchParams);
    for (const [key, value] of Object.entries(patch)) {
      const text = Array.isArray(value) ? value.join(',') : value;
      if (text) next.set(key, text);
      else next.delete(key);
    }
    if (!('page' in patch)) next.delete('page');
    setSearchParams(next, { replace: !('page' in patch) });
  };
  return { searchParams, setSearchParams, page, updateParam };
}

export function useCrmNavigation(base: '/clients' | '/leads') {
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.crmReturnTo;
  const pathname = typeof from === 'string' ? from.split('?')[0] : '';
  const returnTo = pathname === base || (base === '/leads' && pathname === '/leads/pipeline') ? from as string : base;
  const openDetail = (id: string) => navigate(`${base}/${id}`, {
    state: { crmReturnTo: location.pathname + location.search },
  });
  const openCreate = () => navigate(`${base}/new`, { state: { crmReturnTo: location.pathname + location.search } });
  return { openDetail, openCreate, returnTo };
}
